import { useMemo } from 'react';
import { selectProducts } from '@/entities/legacyProducts';
import { useAppSelector } from '@/shared/model';
import { Select } from '@/shared/ui';

interface Props {
  error?: boolean;
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
}

export function ProductSelect({ value, onChange, onBlur, error }: Props) {
  const products = useAppSelector(selectProducts);
  const productsItems = useMemo<{ label: string; value: string }[]>(() => {
    return products
      .map((product) => ({
        label: product.name,
        value: product.id,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [products]);

  return (
    <Select
      sx={{ flexShrink: 0, width: 168 }}
      selectProps={{
        MenuProps: {
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          sx: {
            width: 168,
          },
        },
      }}
      error={error}
      label="Product"
      value={value}
      options={productsItems}
      onChange={onChange}
      onBlur={onBlur}
    />
  );
}
